import { observer } from 'mobx-react';

import style from './IndividualReportsPrintPopup.module.scss';

import { IndividualReportType } from 'chaika-enums';

import { Select } from '@components/Select';
import { Button, ButtonTheme } from '@components/Button';
import { useIndividualReportPopup } from './hooks/useIndividualReportPopup';
import { IndividualReportsPrintPopupDataTest } from './dataTestAttributes';
import { translate } from '@chaika/i18n/helper';
import { store } from '@store';

interface Props {
    legalEntityId: string;
    type: IndividualReportType;
    params: any;
}

export const IndividualReportsPrintPopup = observer(
    ({ legalEntityId, type, params }: Props): React.ReactElement<any> => {
        const { app } = store;
        const { selectedReport, reportOptions, canRenderReport, selectReport, renderReport } = useIndividualReportPopup(
            {
                legalEntityId,
                type,
                params,
            },
        );

        return (
            <div className={style.root}>
                <Select
                    forcePlaceholder
                    placeholder={translate('selectReport')}
                    options={reportOptions}
                    selectedValue={selectedReport}
                    dataTest={IndividualReportsPrintPopupDataTest.TemplateSelect}
                    onChange={selectReport}
                />
                <div className={style.actions}>
                    <Button
                        dataTest={IndividualReportsPrintPopupDataTest.RenderButton}
                        label={translate('downloadReport')}
                        disabled={!canRenderReport}
                        onClick={renderReport}
                    />
                    <Button
                        dataTest={IndividualReportsPrintPopupDataTest.CloseButton}
                        label={translate('close')}
                        theme={ButtonTheme.Secondary}
                        onClick={() => app.showPopup(null)}
                    />
                </div>
            </div>
        );
    },
);
